import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";

import {
  getCertificado,
  rtefuenteProveedor,
  rtefuenterangeProveedor,
  years,
} from "../../slices/certificaciones/certificadosThunks";
import { CardCert } from "../Cards/CardCert";
import LoadingPortal from '../loadings/LoadingPortal';
import { toast } from "react-toastify";

export const Rtefuente = () => {
  const dispatch = useDispatch();
  const { yearsDB, rtefuenteDB, loading } = useSelector(
    (state) => state.certificados
  );

  const [selectedValue, setSelectedValue] = useState(null);
  
  const d = new Date();
  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue
  } = useForm({
    defaultValues:{
      vigencia: null,
    } 
  });

  const onSubmit = (data) => {
    if(data.vigencia === null ) {
      toast.error("Debe seleccionar un valor para realizar la busqueda");
    } else{
      dispatch(rtefuenterangeProveedor(data));
    }
  };
  const getRtefuente = async () => {
    dispatch(rtefuenteProveedor({ vigencia: d.getFullYear() - 1 }));
  };
  const getYearsAvailables = async () => {
    dispatch(years());
  };

  const onClearForm = () => {
    getRtefuente();
    setSelectedValue(null);
    setValue("vigencia", null);
  };

  const getCert = async (value) => {
    let info = Object.assign({}, ...value);
    const data = {
      vigencia: info.vigencia,
      type_cert: 3,
      periodo: 12,
      ciudad: 1,
      nit: info.nit
    };
    dispatch(getCertificado(data));
  };

  useEffect(() => {
    getRtefuente();
    getYearsAvailables();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div className="mt-2">
        <form
          className="row col-12 col-md-12"
          onSubmit={handleSubmit(onSubmit)}
        >
          <div className="col-12 col-md-3">
            <Controller
              name="vigencia"
              defaultValue={""}
              control={control}
              render={({ field, value, name }) => (
                <Select
                  label="Vigencia"
                  placeholder="vigencia"
                  name={field.name}
                  options={yearsDB.map((option, idx) => ({
                    value: option,
                    label: option,
                  }))}
                  value={selectedValue}
                  onChange={(val) =>{
                    setSelectedValue(val);
                    field.onChange(val.value)
                  }}
                />
              )}
            />
            <p>{errors.vigencia?.message}</p>
          </div>
          <div className="col-12 col-md-2">
            <button
              type="submit"
              className="btn btn-danger btn-block font-weight-bold"
            >
              Buscar
            </button>
          </div>
          <div className="col-12 col-md-2">
            <button
              type="button"
              className="btn btn-secondary btn-block font-weight-bold"
              onClick={onClearForm}
            >
              Limpiar
            </button>
          </div>
        </form>
      </div>
      <div className="mt-4 px-2">
        <div className="row">
          {loading ? (            
            <LoadingPortal isOpen={loading} />
          ) : (
            <>
              {rtefuenteDB.length > 0 ? (
                <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4">
                  <CardCert
                    titulo="CERTIFICADO DE RETENCIONES EN LA FUENTE"
                    item={rtefuenteDB}
                    getCertificado={getCert}
                  />
                </div>
              ) : (
                <p>No hay datos</p>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};
